import { FileConfig } from 'web-library';
import { AxiosError } from 'axios';
import { GET_REQUEST_FILE_CONFIGS_QUERY_KEY } from 'web-library/constants/queryKeys';
import { GET_BULK_LIST_EXCEL_CONFIGS_URL } from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GenericErrorResponse } from '../typings';

interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetBulkListExcelFileConfigs = ({ onError, onSuccess }: Input) => {
  const getBulkListExcelFileConfig = async () => {
    const res = await axiosClient.get<FileConfig>(GET_BULK_LIST_EXCEL_CONFIGS_URL());

    return res.data;
  };

  return useCustomQuery(GET_REQUEST_FILE_CONFIGS_QUERY_KEY, getBulkListExcelFileConfig, {
    onSuccess,
    onError,
  });
};
